export enum PhysicalExamModes {
    INCLUDE_ALL = "include_all",
    ABNORMAL_ONLY = "abnormal_only"
}

export function getPhysicalExamModes(str: string): PhysicalExamModes {
    return (Object.values(PhysicalExamModes) as string[]).includes(str) ? (str as PhysicalExamModes) : PhysicalExamModes.ABNORMAL_ONLY;
}